import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const SUCCESS = 'INDUSTRY_HUB_SUCCESS';
export const FAILURE = 'INDUSTRY_HUB_FAILURE';

const initialState = {
  loaded: false,
};

export default function industryHubReducer(state = initialState, action) {
  switch (action.type) {
    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign(
        {},
        {
          error: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    default:
      return state;
  }
}

export function fetchIndustryHubSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchIndustryHubFailure(data) {
  return { type: FAILURE, data };
}

export function fetchIndustryHubAction() {
  return function (dispatch, getState, { Api, i18n }) {
    const {
      pageConfig: { previewMode, siteId, siteTypePath },
    } = getState();

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchIndustryHub({ siteId, siteTypePath })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchIndustryHubSuccess(response));
        } else {
          return dispatch(fetchIndustryHubFailure(response));
        }
      });
  };
}
